import { render } from "./CollectionDetailedSearchOfficialGazette.vue?vue&type=template&id=d6831b80&scoped=true&ts=true"
import script from "./CollectionDetailedSearchOfficialGazette.vue?vue&type=script&lang=ts"
export * from "./CollectionDetailedSearchOfficialGazette.vue?vue&type=script&lang=ts"

import "./CollectionDetailedSearchOfficialGazette.vue?vue&type=style&index=0&id=d6831b80&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src866133389/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6831b80"]])

export default __exports__